/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [前置仓账单批量审核通过↗](http://yapi.yishou.com/project/128/interface/api/30730) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @请求头 `POST /erp/SupplySettle/batchCheckPreStoragePassBill`
 * @更新时间 `2021-10-29 12:03:34`
 */
const batchCheckPreStoragePassBillRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettle/batchCheckPreStoragePassBill",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["bill_ids[]"],
    properties: { "bill_ids[]": { type: "string", description: "账单ids" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: { num: { type: "number" } },
    required: ["num"],
  },
  requestFunctionName: "batchCheckPreStoragePassBill",
  extraInfo: {},
};
/**
 * 接口 [前置仓账单批量审核通过↗](http://yapi.yishou.com/project/128/interface/api/30730) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @请求头 `POST /erp/SupplySettle/batchCheckPreStoragePassBill`
 * @更新时间 `2021-10-29 12:03:34`
 */
export const batchCheckPreStoragePassBill = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(batchCheckPreStoragePassBillRequestConfig, requestData),
    ...args,
  );
};
batchCheckPreStoragePassBill.requestConfig = batchCheckPreStoragePassBillRequestConfig;
/**
 * 接口 [批量提交账单↗](http://yapi.yishou.com/project/128/interface/api/33131) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `合并账单`
 * @请求头 `POST /erp/SupplySettleBill/batchCommit`
 * @更新时间 `2022-02-25 13:53:09`
 */
const batchCommitRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/batchCommit",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    properties: {
      bill_ids: {
        type: "array",
        items: { type: "integer", description: "1" },
        description: "[1,2,3,4]",
      },
    },
    additionalProperties: false,
  },
  responseDataJsonSchema: {},
  requestFunctionName: "batchCommit",
  extraInfo: {},
};
/**
 * 接口 [批量提交账单↗](http://yapi.yishou.com/project/128/interface/api/33131) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `合并账单`
 * @请求头 `POST /erp/SupplySettleBill/batchCommit`
 * @更新时间 `2022-02-25 13:53:09`
 */
export const batchCommit = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(batchCommitRequestConfig, requestData), ...args);
};
batchCommit.requestConfig = batchCommitRequestConfig;
/**
 * 接口 [账单列表↗](http://yapi.yishou.com/project/128/interface/api/33137) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/SupplySettleBill/getList`
 * @更新时间 `2022-03-02 11:04:28`
 */
const getListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["is_dispense"],
    properties: {
      is_dispense: {
        type: "string",
        description: "是否小店分发  0 全部 1 是 2否",
      },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      total: { type: "number" },
      per_page: { type: "string" },
      current_page: { type: "string" },
      last_page: { type: "number" },
      data: {
        type: "array",
        items: {
          type: "object",
          properties: {
            create_time: { type: "string" },
            bill_id: { type: "string" },
            supply_name: { type: "string" },
            supply_id: { type: "string" },
            city: { type: "string" },
            pgname: { type: "string" },
            market_name: { type: "string" },
            status: { type: "string" },
            supply_settle_bill_bill_type: { type: "string" },
            bill_type: { type: "string" },
            pay_time: { type: "null" },
            admin_name: { type: "null" },
            se_pay_num: { type: "string" },
            se_pay_amount: { type: "string" },
            use_ded_num: { type: "string" },
            use_ded_amount: {
              type: "string",
              tag: "爆版4.22.0",
              description: "已有字段, 商品抵扣金额",
            },
            real_pay_num: { type: "string" },
            real_pay_amount: { type: "string" },
            owner_admin_name: { type: "string" },
            bill_start_time: { type: "string" },
            bill_end_time: { type: "string" },
            activity_price: { type: "string" },
            service_fee: { type: "string" },
            refund_service_fee: { type: "string" },
            supply_settle_bill_pay_tool: { type: "string" },
            woid_list: { type: "string" },
            order_num: { type: "string" },
            settle_period: { type: "string" },
            int_status: { type: "string" },
            use_ded: { type: "string" },
            wcg_num: { type: "string" },
            real_pay: { type: "string" },
            real_pay_with_ded: { type: "string" },
            owe_time: { type: "string" },
            is_dispense: {
              type: "string",
              description: "是否小店分发  0 否 1是",
            },
            is_dispense_text: { type: "string", description: "文字描述" },
            activity_fee: {
              type: "string",
              tag: "爆版4.22.0",
              description: "新增字段,活动抵扣费用",
            },
          },
          required: [
            "create_time",
            "bill_id",
            "supply_name",
            "supply_id",
            "city",
            "pgname",
            "market_name",
            "status",
            "supply_settle_bill_bill_type",
            "bill_type",
            "pay_time",
            "admin_name",
            "se_pay_num",
            "se_pay_amount",
            "use_ded_num",
            "use_ded_amount",
            "real_pay_num",
            "real_pay_amount",
            "owner_admin_name",
            "bill_start_time",
            "bill_end_time",
            "activity_price",
            "service_fee",
            "refund_service_fee",
            "supply_settle_bill_pay_tool",
            "woid_list",
            "order_num",
            "settle_period",
            "int_status",
            "use_ded",
            "wcg_num",
            "real_pay",
            "real_pay_with_ded",
            "owe_time",
            "is_dispense_text",
            "is_dispense",
            "activity_fee",
          ],
        },
      },
      optionPg: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "string" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      optionPgMember: {
        type: "array",
        items: {
          type: "object",
          properties: {
            key: { type: "string" },
            label: { type: "string" },
            pgid: { type: "string" },
          },
          required: ["key", "label", "pgid"],
        },
      },
      owner_option: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
      },
      origin: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      statusArr: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      optionPayTools: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      types: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
    },
  },
  requestFunctionName: "getList",
  extraInfo: {},
};
/**
 * 接口 [账单列表↗](http://yapi.yishou.com/project/128/interface/api/33137) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/SupplySettleBill/getList`
 * @更新时间 `2022-03-02 11:04:28`
 */
export const getList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getListRequestConfig, requestData), ...args);
};
getList.requestConfig = getListRequestConfig;
/**
 * 接口 [活动费用退费列表↗](http://yapi.yishou.com/project/128/interface/api/33167) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/listRefundOrder`
 * @更新时间 `2022-03-18 10:12:54`
 */
const listRefundOrderRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ActivityFeeRefund/listRefundOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: [
      "activity_fee_refund_no",
      "supply_id",
      "supply_name",
      "pay_admin",
      "pay_status",
      "pay_tool",
      "create_time",
      "pay_time",
      "page",
      "is_excel",
    ],
    properties: {
      activity_fee_refund_no: { type: "string", description: "退费单号" },
      supply_id: { type: "string", description: "供应商id" },
      supply_name: { type: "string", description: "供应商名称" },
      pay_admin: { type: "string", description: "支付人" },
      pay_status: { type: "string", description: "活动退费状态" },
      pay_tool: { type: "string", description: "支付方式" },
      create_time: { type: "string", description: "退费单生成日期" },
      pay_time: { type: "string", description: "退费日期" },
      page: { type: "string", description: "当前页码" },
      is_excel: { type: "string", description: "是否导出{1:是,0:否}" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: { type: "string", description: "退费单id" },
            activity_fee_refund_no: { type: "string", description: "退费单号" },
            created_at: { type: "string", description: "退费单生成日期" },
            pay_tool_text: { type: "string", description: "支付方式" },
            supply_id: { type: "string", description: "供应商id" },
            supply_name: { type: "string", description: "供应商名称" },
            brand_name: { type: "string", description: "品牌" },
            goods_num: { type: "string", description: "商品总数量" },
            pay_amount: { type: "string", description: "活动费退费总额" },
            pay_status: { type: "string", description: "活动费退费状态" },
            pay_status_text: {
              type: "string",
              description: "活动费退费状态文字",
            },
            pay_admin_name: { type: "string", description: "支付人" },
            pay_time: { type: "string", description: "退费日期" },
          },
          required: [
            "id",
            "activity_fee_refund_no",
            "pay_tool_text",
            "supply_id",
            "supply_name",
            "goods_num",
            "brand_name",
            "pay_amount",
            "pay_admin_name",
            "pay_time",
            "created_at",
            "pay_status",
            "pay_status_text",
          ],
        },
      },
      pay_status_option: {
        type: "array",
        items: {
          type: "object",
          properties: { label: { type: "string" }, key: { type: "number" } },
        },
      },
      pay_tool_option: {
        type: "array",
        items: {
          type: "object",
          properties: { label: { type: "string" }, key: { type: "number" } },
        },
      },
      total: { type: "number", description: "总条目数" },
    },
  },
  requestFunctionName: "listRefundOrder",
  extraInfo: {},
};
/**
 * 接口 [活动费用退费列表↗](http://yapi.yishou.com/project/128/interface/api/33167) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/listRefundOrder`
 * @更新时间 `2022-03-18 10:12:54`
 */
export const listRefundOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(listRefundOrderRequestConfig, requestData), ...args);
};
listRefundOrder.requestConfig = listRefundOrderRequestConfig;
/**
 * 接口 [活动退费详情↗](http://yapi.yishou.com/project/128/interface/api/33168) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/getRefundOrder`
 * @更新时间 `2022-03-16 11:44:34`
 */
const getRefundOrderRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ActivityFeeRefund/getRefundOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["id"],
    properties: { id: { type: "string", description: "活动退费单id" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      activity_fee_refund_no: { type: "string", description: "退费单号" },
      create_time: { type: "string", description: "生成时间" },
      pay_status_text: { type: "string", description: "退费状态" },
      activity_goods_num: { type: "string", description: "退费商品数量" },
      activity_goods_amount: { type: "string", description: "退费商品总金额" },
      activity_goods: {
        type: "array",
        items: {
          type: "object",
          properties: {
            activity_time: { type: "string", description: "活动时间" },
            goods_name: { type: "string", description: "商品名称" },
            goods_no: { type: "string", description: "商品货号" },
            co_si: { type: "string", description: "颜色/尺码" },
            sku: { type: "string", description: "sku" },
            activity_fee: { type: "string", description: "活动费用" },
            num: { type: "number", description: "数量" },
            order_id: { type: "string", description: "订单id" },
            activity_id: { type: "string", description: "活动id" },
            activity_type_text: { type: "string", description: "活动类型文字" },
            activity_type: { type: "string", description: "活动类型" },
            activity_name: { type: "string", description: "活动名称" },
            activity_fee_amount: {
              type: "string",
              description: "活动退费总额",
            },
            goods_img: { type: "string", description: "商品图片" },
            co_val: { type: "string", description: "颜色" },
            si_val: { type: "string", description: "尺码" },
            goods_kh: { type: "string", description: "款号" },
          },
        },
        description: "退费商品列表",
      },
      pay_info: {
        type: "object",
        properties: {
          pay_contact: { type: "string", description: "收款人" },
          pay_bank: { type: "string", description: "收款银行" },
          cnap: { type: "string", description: "联行号" },
          pay_account: { type: "string", description: "收款账号" },
        },
        description: "支付信息",
      },
      logs: {
        type: "array",
        items: {
          type: "object",
          properties: {
            action_admin: { type: "string", description: "操作人" },
            action_type: { type: "string", description: "操作方式" },
            action_result: { type: "string", description: "操作结果" },
            create_time: { type: "string", description: "操作时间" },
            action_ext: { type: "string", description: "操作备注" },
          },
          required: [
            "action_admin",
            "action_type",
            "action_result",
            "create_time",
            "action_ext",
          ],
        },
      },
    },
    required: ["logs"],
  },
  requestFunctionName: "getRefundOrder",
  extraInfo: {},
};
/**
 * 接口 [活动退费详情↗](http://yapi.yishou.com/project/128/interface/api/33168) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/getRefundOrder`
 * @更新时间 `2022-03-16 11:44:34`
 */
export const getRefundOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getRefundOrderRequestConfig, requestData), ...args);
};
getRefundOrder.requestConfig = getRefundOrderRequestConfig;
/**
 * 接口 [账单详情↗](http://yapi.yishou.com/project/128/interface/api/33230) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/SupplySettleBill/billGoods`
 * @更新时间 `2022-03-09 16:14:09`
 */
const billGoodsRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/billGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["bill_id"],
    properties: { bill_id: { type: "string", description: "账单id" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      bill_date: { type: "array", items: { type: "string" } },
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            bill_id: { type: "string" },
            bill_create_time: { type: "string" },
            create_time: { type: "string" },
            kd_create_time: { type: "string" },
            woid: { type: "string" },
            woiid: { type: "string" },
            goods_img: { type: "array", items: { type: "string" } },
            goods_name: { type: "string" },
            goods_no: { type: "string" },
            goods_kh: { type: "string" },
            co_val: { type: "string" },
            si_val: { type: "string" },
            price: { type: "string" },
            num: { type: "string" },
            se_pay_num: { type: "string" },
            supply_id: { type: "string" },
            finish_owe_time: { type: "string" },
            split_num: { type: "string" },
            co_id: { type: "string" },
            si_id: { type: "string" },
            pgid: { type: "string" },
            se_pay_amount: { type: "string" },
          },
        },
      },
      bill_info: {
        type: "object",
        properties: {
          bill_id: { type: "string" },
          settle_id: { type: "string" },
          bill_type: { type: "string" },
          se_pay_num: { type: "string" },
          se_pay_amount: { type: "string" },
          first_target_rate: { type: "string" },
          second_target_rate: { type: "string" },
          freeze_rate: { type: "string" },
          freeze_amount: { type: "string" },
          use_ded_num: { type: "string" },
          use_ded_amount: { type: "string" },
          real_pay_num: { type: "string" },
          real_pay_amount: { type: "string" },
          activity_price: { type: "string" },
          service_fee: { type: "string" },
          refund_service_fee: { type: "string" },
          status: { type: "string" },
          check_time: { type: "string" },
          pay_time: { type: "string" },
          pay_admin: { type: "string" },
          pay_doc: { type: "string" },
          payee_id: { type: "string" },
          create_time: { type: "string" },
          update_time: { type: "string" },
          pay_account: { type: "string" },
          pay_contact: { type: "string" },
          pay_bank: { type: "string" },
          cnap: { type: "string" },
          supply_id: { type: "string" },
          is_delete: { type: "string" },
          pay_tool: { type: "string" },
          woid: { type: "string" },
          ded_activity_fee: {
            type: "string",
            tag: "爆版4.22.0",
            description: "抵扣活动费用",
          },
          cnap_name: { type: "string" },
          bank_is_verify: { type: "number" },
          pay_fail_msg: { type: "string" },
          origin_pay_doc: { type: "array", items: { type: "string" } },
          true_price: { type: "string" },
        },
      },
      supply_info: {
        type: "object",
        properties: {
          supply_name: { type: "string" },
          supply_id: { type: "string" },
          pgname: { type: "string" },
        },
      },
      ded_goods: {
        type: "array",
        items: {
          type: "object",
          properties: {
            price: { type: "string" },
            num: { type: "string" },
            referer_type: { type: "string" },
            referer_type_index: { type: "string" },
            cg_type: { type: "string" },
            co_val: { type: "string" },
            si_val: { type: "string" },
            goods_no: { type: "string" },
            goods_kh: { type: "string" },
            goods_name: { type: "string" },
            goods_img: { type: "array", items: { type: "string" } },
            used_num: { type: "string" },
            woiid: { type: "string" },
          },
          required: [
            "price",
            "num",
            "referer_type",
            "referer_type_index",
            "cg_type",
            "co_val",
            "si_val",
            "goods_no",
            "goods_kh",
            "goods_name",
            "goods_img",
            "used_num",
            "woiid",
          ],
        },
      },
      bank_info: {
        type: "array",
        items: {
          type: "object",
          properties: {
            payee_id: { type: "string" },
            payee_name: { type: "string" },
            payee_bank: { type: "string" },
            payee_bank_account: { type: "string" },
            cnap_name: { type: "string" },
          },
          required: [
            "payee_id",
            "payee_name",
            "payee_bank",
            "payee_bank_account",
            "cnap_name",
          ],
        },
      },
      used_ded: { type: "array", items: { type: "string" } },
      activity_detail: { type: "array", items: { type: "string" } },
      plan_order_goods: {
        type: "object",
        properties: {
          list: {
            type: "array",
            items: {
              type: "object",
              properties: {
                goods_name: { type: "string" },
                goods_no: { type: "string" },
                co_val: { type: "string" },
                si_val: { type: "string" },
                price: { type: "string" },
                bill_info_id: { type: "string" },
                woid: { type: "string" },
                service_rate: { type: "string" },
                refund_service_rate: { type: "string" },
                woiid: { type: "string" },
                planid: { type: "string" },
                goods_type: { type: "string" },
                create_time: { type: "string" },
                num: { type: "string" },
                dbids: { type: "string" },
                main_img: { type: "string" },
                middle_img: { type: "array", items: { type: "string" } },
                activity_fee: { type: "string" },
                service_fee: { type: "string" },
                refund_service_fee: { type: "string" },
                total: { type: "string" },
                true_total: { type: "string" },
                wcg_plan_ptype: { type: "string" },
              },
            },
          },
          total: {
            type: "object",
            properties: {
              price: { type: "string" },
              pay_price: { type: "string" },
              total_num: { type: "string" },
              count: { type: "number" },
            },
          },
        },
      },
      log: {
        type: "array",
        items: {
          type: "object",
          properties: {
            operator: { type: "string" },
            action_type: { type: "string" },
            create_time: { type: "string" },
            action_result: { type: "string" },
          },
        },
      },
    },
  },
  requestFunctionName: "billGoods",
  extraInfo: {},
};
/**
 * 接口 [账单详情↗](http://yapi.yishou.com/project/128/interface/api/33230) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/SupplySettleBill/billGoods`
 * @更新时间 `2022-03-09 16:14:09`
 */
export const billGoods = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(billGoodsRequestConfig, requestData), ...args);
};
billGoods.requestConfig = billGoodsRequestConfig;
/**
 * 接口 [支付活动退费↗](http://yapi.yishou.com/project/128/interface/api/33244) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/payActivityRefundOrder`
 * @更新时间 `2022-03-12 10:11:24`
 */
const payActivityRefundOrderRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ActivityFeeRefund/payActivityRefundOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["ids", "code", "furinfo"],
    properties: {
      ids: { type: "string", description: "退费单id数组" },
      code: { type: "string", description: "验证码" },
      furinfo: { type: "string", description: "用途" },
    },
  },
  responseDataJsonSchema: { type: "object" },
  requestFunctionName: "payActivityRefundOrder",
  extraInfo: {},
};
/**
 * 接口 [支付活动退费↗](http://yapi.yishou.com/project/128/interface/api/33244) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/payActivityRefundOrder`
 * @更新时间 `2022-03-12 10:11:24`
 */
export const payActivityRefundOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(payActivityRefundOrderRequestConfig, requestData),
    ...args,
  );
};
payActivityRefundOrder.requestConfig = payActivityRefundOrderRequestConfig;
/**
 * 接口 [退费单上传回执↗](http://yapi.yishou.com/project/128/interface/api/33248) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/uploadReceipt`
 * @更新时间 `2022-03-16 16:11:10`
 */
const uploadReceiptRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ActivityFeeRefund/uploadReceipt",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["id", "images[]", "images[]"],
    properties: {
      id: { type: "string", description: "退费单id" },
      "images[]": { type: "string", description: "回执照片数组" },
    },
  },
  responseDataJsonSchema: { type: "array", description: "[]" },
  requestFunctionName: "uploadReceipt",
  extraInfo: {},
};
/**
 * 接口 [退费单上传回执↗](http://yapi.yishou.com/project/128/interface/api/33248) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/uploadReceipt`
 * @更新时间 `2022-03-16 16:11:10`
 */
export const uploadReceipt = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(uploadReceiptRequestConfig, requestData), ...args);
};
uploadReceipt.requestConfig = uploadReceiptRequestConfig;
/**
 * 接口 [退费单重新激活↗](http://yapi.yishou.com/project/128/interface/api/33249) 的 **请求配置**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/reactivate`
 * @更新时间 `2022-03-16 16:14:57`
 */
const reactivateRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ActivityFeeRefund/reactivate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["id", "payee_id"],
    properties: {
      id: { type: "string", description: "退费单id" },
      payee_id: { type: "string", description: "供应商收款人账户id" },
    },
  },
  responseDataJsonSchema: { type: "array", description: "[]" },
  requestFunctionName: "reactivate",
  extraInfo: {},
};
/**
 * 接口 [退费单重新激活↗](http://yapi.yishou.com/project/128/interface/api/33249) 的 **请求函数**
 *
 * @分类 [财务↗](http://yapi.yishou.com/project/128/interface/api/cat_2418)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/ActivityFeeRefund/reactivate`
 * @更新时间 `2022-03-16 16:14:57`
 */
export const reactivate = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(reactivateRequestConfig, requestData), ...args);
};
reactivate.requestConfig = reactivateRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/finance.js